/* Notificacoes / push: lista, leitura e registro de dispositivo. */
import {
  notification,
  paginated,
  pushDiagnostics,
  registerDeviceInput,
  type PushDiagnostics,
} from "@zapir/shared";
import { z } from "zod";
import { request } from "./core";
import type { NotificationView, Page } from "./types";

/* Tipos derivados que o shared nao reexporta por nome. */
type RegisterDeviceInput = z.infer<typeof registerDeviceInput>;

export const notificationsApi = {
  async notifications(params?: { tipo?: string; cursor?: string; limit?: number }): Promise<Page<NotificationView>> {
    return request("/notifications", { query: params, schema: paginated(notification) });
  },

  async markNotificationsRead(ids?: string[]): Promise<void> {
    await request("/notifications/read", { method: "POST", body: { ids } });
  },

  async registerDevice(input: RegisterDeviceInput): Promise<void> {
    const body = registerDeviceInput.parse(input);
    await request("/push/devices", { method: "POST", body });
  },

  async pushDiagnostics(): Promise<PushDiagnostics> {
    return request("/push/diagnostics", { schema: pushDiagnostics });
  },

  async subscribeWebPush(subscription: unknown): Promise<void> {
    await request("/push/web/subscribe", { method: "POST", body: { subscription } });
  },
};
